import { usePersistence } from './usePersistence';

const SIDEBAR_COLLAPSED_KEY_PREFIX = 'layout-sidebar-collapsed';

export const getSidebarCollapsedKey = (userIdentifier) =>
  `${SIDEBAR_COLLAPSED_KEY_PREFIX}-${userIdentifier || 'current-user'}`;

/**
 * Persists the signed-in user's desktop sidebar density across portal
 * navigation and page reloads. Mobile drawer visibility is intentionally
 * separate and always starts closed.
 */
export const useSidebarCollapsed = (userIdentifier) =>
  usePersistence(getSidebarCollapsedKey(userIdentifier), false, [true, false]);

export default useSidebarCollapsed;
